import { render } from "./TrashIcon.vue?vue&type=template&id=334cf97a&scoped=true"
const script = {}

import "./TrashIcon.vue?vue&type=style&index=0&id=334cf97a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334cf97a"]])

export default __exports__